module.exports = __webpack_public_path__ + "img/commission-icon.eb0bbe1c.png";